const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* TooCut shop price-display fix (2026-05-06).
   The shop section writes data-sub-1 / data-one-1 etc, but the inline
   IIFE reads card.dataset[mode + pack] (e.g. "sub1") which is undefined
   because hyphen-digit data attributes keep the hyphen in the dataset
   key (per HTML spec). We mirror "sub-1" -> "sub1" so the broken read
   path resolves correctly, then click the already-active pack button
   on each card to trigger the IIFE's refresh() with valid prices. */
(function() {
  function tcShopFix() {
    var cards = document.querySelectorAll('.tc-shop__card');
    if (!cards.length) return;
    cards.forEach(function(card) {
      ['1', '3', '6'].forEach(function(n) {
        var s = card.dataset['sub-' + n];
        var o = card.dataset['one-' + n];
        if (s != null && card.dataset['sub' + n] == null) card.dataset['sub' + n] = s;
        if (o != null && card.dataset['one' + n] == null) card.dataset['one' + n] = o;
      });
    });
    var firstActive = document.querySelector('.tc-shop__card .tc-shop__pack.is-active');
    if (firstActive) {
      try { firstActive.click(); } catch (e) { /* no-op */ }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tcShopFix);
  } else {
    tcShopFix();
  }
})();
